enum TableButtonType {
	LINK = 'LINK',
	EXPORT = 'EXPORT',
	PRIMARY = 'PRIMARY'
}
export default TableButtonType;
